import type { Catalog, ComponentMode, FileOwnerType } from 'types';

interface State extends Catalog {
  mode: ComponentMode;
  step: 1 | 2 | 3;
  ownerType: FileOwnerType;
  defaultTitle: string;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_CATALOG_BRAND';
      payload: Pick<typeof initialState, 'brand'>;
    }
  | {
      type: 'UPDATE_CATALOG_DESCRIPTION';
      payload: Pick<typeof initialState, 'description'>;
    }
  | {
      type: 'UPDATE_CATALOG_FILES';
      payload: Pick<typeof initialState, 'catalogs'>;
    }
  | {
      type: 'UPDATE_CATALOG_SEO';
      payload: Pick<typeof initialState, 'seo'>;
    }
  | {
      type: 'UPDATE_CATALOG_STEP';
      payload: Pick<typeof initialState, 'step'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
